
import 'ksk/styledComponents/components/globals.js'
import './KskInputRico.css';

import React, { useEffect, useRef } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

import 'bootstrap/js/dist/modal'
import 'bootstrap/js/dist/dropdown'
import 'bootstrap/js/dist/tooltip'

// Removido react-summernote e seus estilos


import { useBuildInputId } from 'ksk/styledComponents/components/KskForm/KskForm';

import { InputLabel, Input, FormHelperText } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFont, faPen, faBan } from '@fortawesome/free-solid-svg-icons';
import KskInputHelper from '../KskInputHelper/KskInputHelper';
import { get, isEmpty } from 'lodash';
import classNames from 'classnames';

import { useAtom } from 'jotai';
import { readOnlyModeAtom } from 'contexts/FeatureContext';
import KskInputHidden from '../KskInputHidden/KskInputHidden';
import KskInput from '../KskInput/KskInput';
import KskInputRicoView from './KskInputRicoView';

const RichTextComposedIcon = React.memo(() => (  
  <span className="fa-layers fa-fw" >
    <FontAwesomeIcon icon={faFont} transform="shrink-6 up-2"/>
    <FontAwesomeIcon icon={faPen} transform="shrink-6 right-8 down-2"/>
  </span>
));

function formatIdDOM(id){
    //necesário para os formulário com array
    return id.replaceAll("\.","\\.");
}

function isEmptyContent(content) {
    if(content!=null){
        return content.replaceAll("<br>", "").replaceAll("<p>", "").replaceAll("</p>", "").length <= 0;
    }
    return true;
}

export const KskInputRico = React.forwardRef(({
    name,
    id,
    form,
    errors,
    className,
    label,
    required,
    optional,
    helperText,
    height,
    maxHeight,
    width,    
    disabled,
    readOnly,
    defaultValue

},ref)=>{

    // TODO parece nao fazer sentido React.forwardRef pois o ref nao é usado
    const _id = useBuildInputId({id,name})
    const _idReactSummernote = _id + "ReactSummernote"
    const _idDOM = '#' + formatIdDOM(_idReactSummernote)

    const _errors = form?.formState?.errors || errors;
    const error = get(_errors,name)
    const errorText = error?.message;
    const hasErrors = !isEmpty(error);

    const [readOnlyMode] = useAtom(readOnlyModeAtom);
    const _readOnly = readOnly || readOnlyMode;
    const suffix = required ? ' *' : ''
    maxHeight = maxHeight?maxHeight:height;

    const showHelper = hasErrors || !!helperText || !!optional || !!required;
    const helper = showHelper ? (
      <FormHelperText
        className={classNames('ksk-input-rico__helper', {'Mui-error': hasErrors})}
        sx={{ mt: '3px', ml: '14px', mr: 0, mb: 0 }}
      >
        <KskInputHelper {...{optional, required, hasErrors, name, errorsObj:_errors, helperText, readOnly:_readOnly}} />
      </FormHelperText>
    ) : null;

    const summernoteInternalRef = useRef();

    useEffect(() => {
      if (ref && typeof ref === "object") {
        ref.current = summernoteInternalRef.current;
      }
    }, [ref]);

    function onChangeReactSummernote(content){                
        if(isEmptyContent(content)){
            form.setValue(name, '');
        }else{
            form.setValue(name, content);
        }
        form.trigger(name);
    }    

    return (
       <>
        {/* porque o kskinputhidden nao funcionou? */}
        {/* <KskInputHidden form={form} name={name} value={defaultValue}/> */}
        <KskInput form={form} name={name} defaultValue={defaultValue} hidden/>

        <div id={_idReactSummernote} className={ classNames('ksk-input-rico', {'ksk-input-rico--readonly': _readOnly, 'ksk-input-rico--error': hasErrors},className)} >   

            <InputLabel htmlFor={_id} error={!!error} disabled={_readOnly}>
            <span style={{marginRight: '0.333em'}}>{!_readOnly && <RichTextComposedIcon/> }</span>
            <span>{label + suffix}</span>
            </InputLabel>

            {!readOnlyMode
                ? <div
                    className="ksk-input-rico__editor-wrapper mb-4"
                    style={{
                      height: height,
                      maxHeight: maxHeight,
                      width: width || "100%",
                      border: hasErrors ? '2px solid #f44336' : undefined
                    }}
                  >
                    <ReactQuill
                      value={form.watch(name) ?? ""}
                      onChange={onChangeReactSummernote}
                      theme="snow"
                      style={{
                        height: '100%',
                        width: '100%',
                        marginBottom: 0
                      }}
                      modules={{
                        toolbar: [
                          ['bold', 'italic', 'underline', 'strike'],
                          ['blockquote', 'code-block'],
                          [{ 'list': 'ordered'}, { 'list': 'bullet' }],
                          [{ 'header': 1 }, { 'header': 2 }],
                          ['link'],
                          ['clean']
                        ]
                      }}
                    />
                  </div>
                : <KskInputRicoView 
                    value={form.watch(name)??""}
                    label={label}
                    withLabel={false}
                    height={height}
                    width={width}
                />
            }     

            {helper}     

            {/* { errorText && <FormHelperText error={!!errorText}>{errorText}</FormHelperText> }    */}

        </div>
       </>
    );

});

export default KskInputRico;